import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { Box, Card, CardHeader, IconButton, Stack } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import { MotorBodyTypeForm } from "./components/motorBodyTypeForm";
import { postData } from "../../../services";
import { useLoading } from "../../../components/Loading";
import { useSnackbar } from "../../../context/popup";

const AddMotorBodyType = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const { setCircleLoading } = useLoading();

  const handleAddBodyType = async (bodyTypeData) => {
    setCircleLoading(true);
    try {
      const bodyTypePostData = {
        name: bodyTypeData.name,
        isActive: bodyTypeData.active,
      };

      const response = await postData(
        "/reference/motor/body-type",
        bodyTypePostData
      );

      const responseMessage = response?.message;
      if (response?.success) {
        showSnackbar(responseMessage, "success");
        navigate("/motor-master/motor-bodyType");
      } else {
        showSnackbar(responseMessage,"error");
      }
    } catch (error) {
      console.error("Error Submitting",error);
      showSnackbar(error?.response?.data?.message,"error")
    }
    finally{
      setCircleLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton
                  onClick={() => navigate("/motor-master/motor-bodyType")}
                >
                  <ArrowBack />
                </IconButton>
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Add Body Type details
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    Add Body Type details here.
                  </MaterialTypography>
                </Stack>
              </Stack>
            </Stack>
          }
        />
        <Box>
          <MotorBodyTypeForm onsubmit={handleAddBodyType} />
        </Box>
      </Card>
    </DashboardLayout>
  );
};

export default AddMotorBodyType;
